<template>
    <div>
        <div class="modal hide fade" id="modalVendorForm" tabindex="-1" role="dialog" aria-labelledby="modalVendorForm" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Vendor
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="name" class="col-sm-3 col-form-label text-left">Type</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.type_id" class="form-control">
                                                    <option v-for="v in vendorTypeList" :key="v.id" :value="v.id">{{ v.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.name" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="alias" class="col-sm-3 col-form-label text-left">Alias</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.alias" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
                                            <div class="col-sm-9">
                                                <input type="text" class="form-control" v-model="vendor.email"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                            <div class="col-sm-9">
                                                <input type="text" class="form-control" v-model="vendor.phone"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="mobile" class="col-sm-3 col-form-label text-left">Mobile</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.mobile" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="vat" class="col-sm-3 col-form-label text-left">Vat</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.vat" class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                                            <div class="col-sm-9">
                                                <textarea rows="5" v-model="vendor.address" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.state_id" class="form-control">
                                                    <option v-for="c in stateList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="city_id" class="col-sm-3 col-form-label text-left">City</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.city_id" class="form-control">
                                                    <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="postalcode" class="col-sm-3 col-form-label text-left">Postal Code</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.postalcode" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <hr>
                                    <div class="col-md-12">
                                        <h3>Contact</h3>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="contact_name" class="col-sm-3 col-form-label text-left">Name</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.contact[0].name" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_email" class="col-sm-3 col-form-label text-left">Email</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.contact[0].email" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.contact[0].phone" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_mobile" class="col-sm-3 col-form-label text-left">Mobile</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.contact[0].mobile" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_vat" class="col-sm-3 col-form-label text-left">vat</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.contact[0].vat" class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="contact_address" class="col-sm-3 col-form-label text-left">address</label>
                                            <div class="col-sm-9">
                                                <textarea cols="5" v-model="vendor.contact[0].address" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_state_id" class="col-sm-3 col-form-label text-left">State</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.contact[0].state_id" class="form-control">
                                                    <option v-for="c in stateList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_city_id" class="col-sm-3 col-form-label text-left">City</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.contact[0].city_id" class="form-control">
                                                    <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_postalcode" class="col-sm-3 col-form-label text-left">Poostal Code</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.contact[0].postalcode" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_notes" class="col-sm-3 col-form-label text-left">Notes</label>
                                            <div class="col-sm-9">
                                                <textarea rows="5" v-model="vendor.contact[0].notes" class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { vendorUrl, getHeader } from '../../config'
export default {
  name: 'VendorFormModal',
  data () {
    return {
      money: {
        total: '0',
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      vendor: {
        id: null,
        vendor_no: null,
        type_id: null,
        name: null,
        email: null,
        phone: null,
        mobile: null,
        vat: null,
        address: null,
        city_id: null,
        state_id: null,
        postalcode: null,
        type: null,
        alias: null,
        contact: [{
          id: null,
          vendor_no: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          notes: null
        }]
      }
    }
  },
  computed: {
    ...mapState({
      cityList: state => state.city.cityList,
      stateList: state => state.state.stateList,
      vendorTypeList: state => state.vendors.vendorTypeList
    })
  },
  methods: {
    save: function () {
      console.log(this.vendor)
      console.log(vendorUrl)
      axios.post(vendorUrl, this.vendor, { headers: getHeader() })
        .then(response => {
          this.$emit('createVendor', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  }
}
</script>
